<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="Theo dõi trực tiếp"
          :link="[
            {
              text: 'Xe tuyến',
              href: '../busList'
            }
          ]"
        />
      </div>
    </div>

    <v-card v-if="role.type !== 'buslist'" outlined class="pa-6 mx-4 mb-6 elevation-0">
      <BusTrackingFilter @onFilterChanged="refresh" />
    </v-card>

    <v-card outlined class="mx-4 elevation-0">
      <BusTrackingMap :query="query" />
    </v-card>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import { mapGetters } from 'vuex'
import BusTrackingMap from '../../modules/bus/BusTrackingMap.vue'
import BusTrackingFilter from '../../modules/bus/BusTrackingFilter.vue'

export default {
  components: {
    Breadcrumbs,
    BusTrackingFilter,
    BusTrackingMap
  },
  props: {},
  data() {
    return {
      newDialog: false,
      selected: [],
      query: {},
      description: '',
      name: '',
      status: '',
      driver: '',
      phone: '',
      data: {
        maxStudent: ''
      },
      maxStudent: '',
      statusDefault: 'active'
    }
  },
  computed: {
    ...mapGetters('auth', ['profile', 'role', 'user', 'isEditDocument'])
  },
  methods: {
    async refresh(query) {
      this.query = query
    }
  },
  created() {
    this.status = this.statusDefault
  }
}
</script>
<style scoped></style>
